// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3BJTp","header":"MergedInvoice_header__2sqvs"};